import { Box, Flex, Image } from '@chakra-ui/react';

import loginImage from 'Asset/image/login-image.jpg';

import styles from './styles.module.css';
import Form from './section/form';
import Head from './section/head';
import Error from './section/error';
import LoginProvider from 'View/login/state';

const Login = () => {
  return (
    <Flex className={styles['login__container']} data-testid="login__container">
      <Box className={styles['section__container--left']}>
        <Image src={loginImage} className={styles['login__image']} />
      </Box>
      <Box className={styles['section__container--right']}>
        <Box className={styles['box__container']}>
          <Head />
          <Error />
          <Form />
        </Box>
      </Box>
    </Flex>
  );
};

const LoginContainer = () => <LoginProvider children={<Login />} />;

export default LoginContainer;
